import Page from '../../components/Page';
import React from 'react';
import {Button, Form, FormGroup, Input, Label, Col, Row, Card, CardBody, CardHeader} from 'reactstrap';
import {FormBuilder, FieldGroup, FieldControl, Validators,} from "react-reactive-form";
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import {login} from "../../actions/userAction";
import connect from "react-redux/es/connect/connect";
import {USER_TYPE} from "../../constants/appConstants";
import API from "../../resources/index";

class ManagerFormPage extends React.Component {
    managerResource = API.managerResource;

    constructor() {
        super();
        this.state = {
            manager: {},
        };
    }

    managerForm = FormBuilder.group({
        name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        password: ['', Validators.required],
        is_activated: [0]
    });

    componentDidMount() {
        if (this.props.match.params && this.props.match.params.manager_id) {
            this.managerResource.fetch(this.props.match.params.manager_id, {keys: {expand: ['auth']}})
                .then(response => {
                    if (response.status === 200) {
                        this.setState({manager: response.data});
                        this.managerForm.controls['password'].setValidators([]);
                        this.managerForm.controls['password'].updateValueAndValidity();
                        for (let control in this.managerForm.controls) {
                            if (response.data[control]) {
                                this.managerForm.controls[control].setValue(response.data[control]);
                            } else if (response.data.auth[control]) {
                                this.managerForm.controls[control].setValue(response.data.auth[control]);
                            }
                        }
                    }
                })
        }
    }

    onSubmit = (event) => {
        event.preventDefault();
        if (this.state.manager.id) {
            this.managerResource.put(this.state.manager.id, this.managerForm.value, {keys: {expand: ['auth']}})
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.auth.id === this.props.user.id) {
                            const user = {
                                id: response.data.auth.id,
                                email: response.data.auth.email,
                                accessToken: response.data.auth.access_token,
                                name: response.data.name,
                                level: USER_TYPE.MANAGER
                            };

                            this.props.storeUser(user);
                            localStorage.setItem('userReducer', JSON.stringify(user));
                        }
                        this.props.history.push(`/managers/detail/${response.data.id}`);
                    }
                })
        } else {
            this.managerResource.create(this.managerForm.value)
                .then(response => {
                    if (response.status === 201)
                        this.props.history.push(`/managers/detail/${response.data.id}`);
                })
        }
    };

    render() {
        const {manager} = this.state;
        return <Page
            title={(manager.id ? 'Editar' : 'Novo') + ' Gestor'}
            icon='MdGroup'
            // breadcrumbs={[
            //     {name: 'Gestores', active: false},
            //     {name: (manager.id ? 'Editar' : 'Novo') + ' Gestor', active: true}
            // ]}
            className="">
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            <Link className='btn btn-outline-secondary mr-2'
                                  to={`/managers`}>
                                Gestores
                            </Link>

                            {manager.id &&
                            <Link className='btn btn-outline-secondary mr-2' to={`/managers/detail/${manager.id}`}>
                                Ver
                            </Link>}
                        </CardHeader>
                        <CardBody>
                            <FieldGroup
                                control={this.managerForm}
                                render={({get, invalid}) => (
                                    <Form onSubmit={this.onSubmit}>

                                        <FieldControl
                                            name="name"
                                            render={({handler, touched, hasError, meta}) => (
                                                <FormGroup>
                                                    <Label for="Name">Nome</Label>
                                                    <Input type="text" id="Name" {...handler()}/>
                                                    <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                </FormGroup>
                                            )}
                                            meta={{label: "Nome"}}
                                        />

                                        <FieldControl
                                            name="email"
                                            render={({handler, touched, hasError, meta}) => (
                                                <FormGroup>
                                                    <Label for="Email">Email</Label>
                                                    <Input type="email" id="Email"  {...handler()}/>
                                                    <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                </FormGroup>
                                            )}
                                            meta={{label: "Email"}}
                                        />

                                        <FieldControl
                                            name="password"
                                            render={({handler, touched, hasError, meta}) => (
                                                <FormGroup>
                                                    <Label for="Password">Senha</Label>
                                                    <Input type="password" id="Password" {...handler()}/>
                                                    <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatória`}
                                                    </span>
                                                </FormGroup>
                                            )}
                                            meta={{label: "Senha"}}
                                        />

                                        <FieldControl
                                            name="is_activated"
                                            render={({handler, touched, hasError, meta}) => (
                                                <FormGroup>
                                                    <Label for="Status">Status</Label>
                                                    <Input type="select" id="Status" {...handler()}>
                                                        <option value={1}>Ativo</option>
                                                        <option value={0}>Inativo</option>
                                                    </Input>
                                                    <span>
                                                        {touched
                                                        && hasError("required")
                                                        && `${meta.label} é obrigatório`}
                                                    </span>
                                                </FormGroup>
                                            )}
                                            meta={{label: "Status"}}
                                        />

                                        <FormGroup>
                                            <Button disabled={invalid}>Salvar</Button>
                                        </FormGroup>
                                    </Form>
                                )}/>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    };
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({storeUser: login}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ManagerFormPage);



// WEBPACK FOOTER //
// ./src/pages/manager/ManagerFormPage.js